export * from './env';
export * from './tools';
export * from './flow';

export const commuityUrls = {
  test: 'https://www-test.liblib.art/modelinfo/',
  pre: 'https://www-pre.liblib.art/modelinfo/',
  prod: 'https://www.liblib.art/modelinfo/',
};
